/**
 * Show/hide functionality for Accordion compoenent.
 */
export default function () {
  if ($('.accordion, .js-accordion-button').length===0) {
    return;
  }

  $('.accordion__title-js').click(function () {
    $('.accordion__content-js').not($(this).next()).slideUp(400);
    $('.accordion__item').not($(this).next()).removeClass('open-accordion');

    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown(400);
      $(this).closest('.accordion__item').toggleClass('open-accordion');
    } else {
      $(this).next().slideUp(400);
      $('.accordion__item').not($(this).closest('.accordion__item')).removeClass('open-accordion');
    }
  });

  // Facets
  $('.facet-accordion .js-accordion-button').click(function () {
    $('.facet-accordion .facetwp-facet').slideUp(400);
    $('.js-accordion-button').removeClass('active');

    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown(400);
      $(this).addClass('active');
    } else {
      $(this).next().slideUp(400);
      $(this).removeClass('active');
    }
  });
}
